module.exports = __webpack_public_path__ + "static/media/variation.1012aeeb.png";